export const dispose = disposable => disposable.dispose()

export const emptyDisposable = {
  dispose () {}
}
